import client from "./clients/portalClient";

const getAllProducts = () => client.get(`/webshop/products`);
const getSingleProduct = (id, data) => client.get(`/webshop/products/${id}`, data);

const xconnectWebshopApi = {
    getAllProducts,
    getSingleProduct,
};

export default xconnectWebshopApi;
